import { useTransition } from "@react-spring/web";

export const useModalTransition = (currentModal: number | undefined) =>
  useTransition(currentModal, {
    from: { transform: "scale(0)", display: "inline-block" },
    enter: { transform: "scale(1)", display: "inline-block" },
    leave: { display: "none" },
    config: { duration: 200 },
  });
